module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uAbe5z/tc-custom/9780547563848.jpg?1734284468401",
      "alt": "This image is the cover for the book Clergyman's Daughter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Clergyman's Daughter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A pious young woman grapples with a loss of memory—and of faith—in this sharp, witty novel by the author of "), _c('i', [_vm._v("1984 ")]), _vm._v("and "), _c('i', [_vm._v("Animal Farm")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v(" Dorothy is the daughter of the Reverend Charles Hare, rector of St. Athelstan’s in Depression-era Suffolk, England. She serves as a dutiful housekeeper, performs good works, cultivates good thoughts—and pricks her arm with a pin when a bad thought arises."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But even as she toils away making costumes for the church school play, she is haunted by thoughts about the poverty that surrounds her and the debts she can’t afford to pay. Then, suddenly, she finds herself in London. She is wearing silk stockings, has money in her pocket, and cannot remember her own name . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This novel of a woman thrust into a strange journey, struck by amnesia and grappling with questions of faith and identity in a world of unemployment and hunger, is a masterful work of satire by one of the great writers of the twentieth century.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George Orwell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("George Orwell (1903–1950) was born in India and served with the Imperial Police in Burma before joining the Republican Army in the Spanish Civil War. He was the author of six novels as well as numerous essays and nonfiction works.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0